import React from "react";
import { Flower2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Logo({ size = "md", showText = true, className }) {
  const dims = { sm: "h-8 w-8", md: "h-10 w-10", lg: "h-14 w-14" };
  const icon = { sm: 16, md: 20, lg: 28 };
  const title = { sm: "text-sm", md: "text-base", lg: "text-xl" };
  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="app-logo">
      <div className={cn(
        "flex items-center justify-center rounded-full border-2 shrink-0",
        "bg-primary text-primary-foreground border-accent/40 shadow-sm",
        dims[size]
      )}>
        <Flower2 size={icon[size]} strokeWidth={1.8} />
      </div>
      {showText && (
        <div className="leading-none">
          <div className={cn("font-heading font-extrabold tracking-tight text-foreground", title[size])}>
            THE LOTUS ACADEMY
          </div>
          {size !== "sm" && (
            <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-1">
              Excellence in Education
            </div>
          )}
        </div>
      )}
    </div>
  );
}
